

// import React, { useState } from "react";
// import ProductForm from "./ProductForm";
// import ProductTable from "./ProductTable";

// const Product = () => {
//   const [isFormVisible, setFormVisible] = useState(false);
//   const [currentProduct, setCurrentProduct] = useState(null); // Store the entire product object
//   const [refreshFlag, setRefreshFlag] = useState(false);

//   const handleAdd = () => {
//     setCurrentProduct(null);
//     setFormVisible(true);
//   };

//   const handleEdit = (product) => {
//     setCurrentProduct(product); // Store the product data
//     setFormVisible(true);
//   };

//   const handleSave = () => {
//     setFormVisible(false);
//     setRefreshFlag((prev) => !prev);
//   };

//   return isFormVisible ? (
//     <ProductForm
//       product={currentProduct} // Pass the product data
//       onCancel={() => setFormVisible(false)}
//       onSave={handleSave}
//     />
//   ) : (
//     <ProductTable 
//       onAdd={handleAdd} 
//       onEdit={handleEdit} 
//       refreshFlag={refreshFlag} 
//     />
//   );
// };

// export default Product;




import React, { useState, useEffect } from "react";
import ProductForm from "./ProductForm";
import ProductTable from "./ProductTable";

const Product = () => {
  const [isFormVisible, setFormVisible] = useState(false);
  const [currentProduct, setCurrentProduct] = useState(null);
  const [refreshFlag, setRefreshFlag] = useState(false);

  useEffect(() => {
    if (isFormVisible) {
      window.history.pushState({ formOpen: true }, '', window.location.pathname);

      const handlePopState = (event) => {
        if (isFormVisible) {
          event.preventDefault();
          setFormVisible(false);
          setCurrentProduct(null);
          window.history.pushState({ formOpen: true }, '', window.location.pathname);
        }
      };

      window.addEventListener('popstate', handlePopState);

      return () => {
        window.removeEventListener('popstate', handlePopState);
      };
    }
  }, [isFormVisible]);

  const handleAdd = () => {
    setCurrentProduct(null);
    setFormVisible(true);
  };

  const handleEdit = (product) => {
    setCurrentProduct(product);
    setFormVisible(true);
  };

  const handleSave = () => {
    setFormVisible(false);
    setCurrentProduct(null);
    setRefreshFlag((prev) => !prev);
  };

  return isFormVisible ? (
    <ProductForm
      product={currentProduct}
      onCancel={() => setFormVisible(false)}
      onSave={handleSave}
    />
  ) : (
    <ProductTable
      onAdd={handleAdd}
      onEdit={handleEdit}
      refreshFlag={refreshFlag}
    />
  );
};

export default Product;